var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as viem from 'viem';
import IERC7412 from '../../contracts/abis/IERC7412.json';
export class EIP7412 {
    constructor(adapters, multicallFunc) {
        this.adapters = new Map();
        adapters === null || adapters === void 0 ? void 0 : adapters.forEach((adapter) => {
            this.adapters.set(adapter.getOracleId(), adapter);
        });
        this.multicallFunc = multicallFunc;
    }
    enableERC7412(client, tx, predefinedOracles = []) {
        return __awaiter(this, void 0, void 0, function* () {
            let multicallCalls = [tx];
            while (true) {
                try {
                    if (!this.multicallFunc) {
                        throw new Error('multicallFunc is not defined');
                    }
                    else {
                        const multicallTxn = this.multicallFunc(multicallCalls);
                        yield client.call(multicallTxn);
                        return multicallTxn;
                    }
                }
                catch (error) {
                    const err = viem.decodeErrorResult({
                        abi: IERC7412.abi,
                        data: parseError(error),
                    });
                    if (err.errorName === 'OracleDataRequired') {
                        const oracleQuery = err.args[1];
                        const oracleAddress = err.args[0];
                        const oracleId = viem.hexToString(viem.trim((yield client.readContract({
                            abi: IERC7412.abi,
                            address: oracleAddress,
                            functionName: 'oracleId',
                            args: [],
                        })), { dir: 'right' }));
                        const adapter = this.adapters.get(oracleId);
                        if (adapter === undefined) {
                            throw new Error(`oracle ${oracleId} not supported (supported oracles: ${Array.from(this.adapters.keys()).join(',')})`);
                        }
                        const signedRequiredData = yield adapter.fetchOffchainData(client, oracleAddress, oracleQuery, predefinedOracles);
                        multicallCalls.splice(multicallCalls.length - 1, 0, {
                            to: err.args[0],
                            // 5 Wei for orcale updates
                            value: BigInt(5),
                            data: viem.encodeFunctionData({
                                abi: IERC7412.abi,
                                functionName: 'fulfillOracleQuery',
                                args: [signedRequiredData],
                            }),
                        });
                    }
                    else if (err.errorName === 'FeeRequired') {
                        const requiredFee = err.args[0];
                        multicallCalls[multicallCalls.length - 2].value = requiredFee;
                    }
                    else {
                        throw error;
                    }
                }
            }
        });
    }
}
function parseError(error) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    try {
        if ((_c = (_b = (_a = error.cause) === null || _a === void 0 ? void 0 : _a.cause) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.data) {
            return (_f = (_e = (_d = error.cause) === null || _d === void 0 ? void 0 : _d.cause) === null || _e === void 0 ? void 0 : _e.error) === null || _f === void 0 ? void 0 : _f.data;
        }
        if ((_k = (_j = (_h = (_g = error.cause) === null || _g === void 0 ? void 0 : _g.cause) === null || _h === void 0 ? void 0 : _h.cause) === null || _j === void 0 ? void 0 : _j.error) === null || _k === void 0 ? void 0 : _k.data) {
            return (_p = (_o = (_m = (_l = error.cause) === null || _l === void 0 ? void 0 : _l.cause) === null || _m === void 0 ? void 0 : _m.cause) === null || _o === void 0 ? void 0 : _o.error) === null || _p === void 0 ? void 0 : _p.data;
        }
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error('exception in erc7412 error parser:', err);
    }
    // rethrow the error (and log it so we can see the original)
    // eslint-disable-next-line no-console
    console.error('got unknown error in erc7412 parse', error);
    throw error;
}
